var quizQuestions = [
    {
        question: "When was this photo taken?",
        image: "/images/cassie_first_kiss.jpg",
        answers: [
            {
                type: "ok",
                content: "First night we went out"
            },
            {
                type: "terrible",
                content: "It was taken on the night we went bowling"
            },

            {
                type: "amazing",
                content: "The night of the first kiss"
            }
        ]
    },
    {
        question: "Where was this photo taken?",
        image: "/images/view_on_way_to_jervis.jpg",
        answers: [
            {
                type: "ok",
                content: "This is a viewpoint somewhere south"
            },
            {
                type: "amazing",
                content: "This is mount Keira"
            },
            {
                type: "terrible",
                content: "This is a viewpoint North of sydney"
            }
        ]
    },
    {
        question: "What kind of event was this photo taken at",
        image: "/images/cherry_blossom.jpg",
        answers: [
            {
                type: "terrible",
                content: "This was at the newtown festival"
            },
            {
                type: "ok",
                content: "I wasn't at this festival"
            },
            {
                type: "amazing",
                content: "This was at the cherry blossom festival"
            }
        ]
    },
    {
        question: "When was this photo taken?",
        image: "/images/view_from_date_night.jpg",
        answers: [
            {
                type: "ok",
                content: "When we walked on the other side of the bridge"
            },
            {
                type: "amazing",
                content: "When we had a date night"
            },
            {
                type: "terrible",
                content: "I have no idea"
            }        ]
    },
    {
        question: "When was this photo taken?",
        image: "/images/eom_simpsons.jpg",
        answers: [
            {
                type: "terrible",
                content: "At a night out"
            },
            {
                type: "ok",
                content: "This is a photo from the simpsons"
            },
            {
                type: "amazing",
                content: "At the End of month at holy moley"
            }
        ]
    },
    {
        question: "When was this photo taken?",
        image: "/images/bus_wine_cassie_birthday.jpg",
        answers: [
            {
                type: "terrible",
                content: "On the way to the blue mountains"
            },
            {
                type: "amazing",
                content: "On cassie's birthday last year"
            },
            {
                type: "ok",
                content: "In the hunter valley"
            }

        ]
    },
    {
        question: "Where was our first holiday together?",
        image: "/images/taj_mahal.jpg",
        answers: [
            {
                type: "terrible",
                content: "Europe"
            },
            {
                type: "ok",
                content: "India"
            },
            {
                type: "amazing",
                content: "Jervis Bay"
            }
        ]
    },
    {
        question: "How much fun was this?",
        image: "/images/elephant.gif",
        answers: [
            {
                type: "amazing",
                content: "Such an amazing experience"
            },
            {
                type: "terrible",
                content: "Boring"
            },
            {
                type: "ok",
                content: "Pretty fun"
            }
        ]
    },
    {
        question: "Who is the creepy santa?",
        image: "/images/creepy_santa.jpg",
        answers: [
            {
                type: "terrible",
                content: "Hamish"
            },
            {
                type: "terrible",
                content: "Dane"
            },
            {
                type: "amazing",
                content: "Simon"
            }
        ]
    },
    {
        question: "When was this glorious photo taken?",
        image: "/images/nye_eve.jpg",
        answers: [
            {
                type: "ok",
                content: "At some face painting somewhere"
            },
            {
                type: "terrible",
                content: "Newtown festival"
            },
            {
                type: "amazing",
                content: "New years eve"
            }
        ]
    },
    {
        question: "When and where was this photo taken?",
        image: "/images/hiking_blue_mountains.jpg",
        answers: [
            {
                type: "ok",
                content: "When we went for a hike"
            },
            {
                type: "terrible",
                content: "When we went to the Ku-ring-gai Chase National Park"
            },
            {
                type: "amazing",
                content: "When we went hiking in the blue mountains"
            }
        ]
    },
    {
        question: "What happened this day?",
        image: "/images/inflatable.jpg",
        answers: [
            {
                type: "ok",
                content: "Cassie rode a unicorn"
            },
            {
                type: "terrible",
                content: "I took a bath with a unicorn"
            },
            {
                type: "amazing",
                content: "We did an inflatables race in Manly"
            }
        ]
    },
    {
        question: "Where is this?",
        image: "/images/scotland_kelpies.jpg",
        answers: [
            {
                type: "ok",
                content: "Scotland"
            },
            {
                type: "terrible",
                content: "Europe"
            },
            {
                type: "amazing",
                content: "The Kelpies"
            }
        ]
    },
    {
        question: "Where was this photo taken?",
        image: "/images/ben_lomond.jpg",
        answers: [
            {
                type: "amazing",
                content: "Ben Lomond"
            },
            {
                type: "terrible",
                content: "Kirkjufell"
            },
            {
                type: "ok",
                content: "Loch Lomond and The Trossachs National Park"
            }
        ]
    },
    {
        question: "Who is the cute little girl?",
        image: "/images/elliyya.jpg",
        answers: [
            {
                type: "amazing",
                content: "Elliyya"
            },
            {
                type: "terrible",
                content: "Cassie"
            },
            {
                type: "ok",
                content: "Kara"
            }
        ]
    },
    {
        question: "What did we have for lunch here?",
        image: "/images/tomato.jpg",
        answers: [
            {
                type: "amazing",
                content: "Tomato soup"
            },
            {
                type: "terrible",
                content: "A salad"
            },
            {
                type: "ok",
                content: "Wine"
            }
        ]
    },
    {
        question: "What happened here?",
        image: "/images/cas_rock.jpg",
        answers: [
            {
                type: "amazing",
                content: "Someone went to pee and photographed the other person"
            },
            {
                type: "terrible",
                content: "Nothing happened here"
            },
            {
                type: "ok",
                content: "Cassie stood on a rock"
            }
        ]
    },
    {
        question: "What is the technical term for this?",
        image: "/images/aurora.jpg",
        answers: [
            {
                type: "amazing",
                content: "aurora borealis"
            },
            {
                type: "terrible",
                content: "aurora australis"
            },
            {
                type: "ok",
                content: "Northern lights"
            }
        ]
    },
    {
        question: "What city is this?",
        image: "/images/doha.jpg",
        answers: [
            {
                type: "amazing",
                content: "Doha"
            },
            {
                type: "terrible",
                content: "Amsterdam"
            },
            {
                type: "ok",
                content: "Qatar"
            }
        ]
    },
    {
        question: "When was this photo taken?",
        image: "/images/dog_selfie.jpg",
        answers: [
            {
                type: "amazing",
                content: "Michele's birthday"
            },
            {
                type: "terrible",
                content: "When we went to newtown"
            },
            {
                type: "ok",
                content: "4mation scavenger hunt"
            }
        ]
    },
    {
        question: "What did we do this day?",
        image: "/images/selfie_couple.jpg",
        answers: [
            {
                type: "ok",
                content: "Went for a swim at the beach"
            },
            {
                type: "terrible",
                content: "Wakeboarding"
            },
            {
                type: "amazing",
                content: "Kayaking and hiking"
            }
        ]
    },
    {
        question: "Where was this photo taken?",
        image: "/images/cassie_jumping.gif",
        answers: [
            {
                type: "ok",
                content: "Mount Tomah"
            },
            {
                type: "terrible",
                content: "Wentworth Falls"
            },
            {
                type: "amazing",
                content: "Mount Wilson"
            }
        ]
    },
    {
        question: "How fun was ice skating?",
        image: "/images/tom_kissing_cassie.jpg",
        answers: [
            {
                type: "ok",
                content: "Meh"
            },
            {
                type: "terrible",
                content: "SOoooo lame"
            },
            {
                type: "amazing",
                content: "I had great fun"
            }
        ]
    },
    {
        question: "Where was this taken?",
        image: "/images/tom_cassie_thredbo.jpg",
        answers: [
            {
                type: "ok",
                content: "Snowy mountains"
            },
            {
                type: "terrible",
                content: "New zealand"
            },
            {
                type: "amazing",
                content: "Thredbo"
            }
        ]
    },
    {
        question: "What does tough titties mean?",
        image: "/images/tough_titties.jpg",
        answers: [
            {
                type: "ok",
                content: "Short version of the phrase \"'Tough titty', said the kitty, when the milk went dry."
            },
            {
                type: "terrible",
                content: "Cassie has tough titties"
            },
            {
                type: "amazing",
                content: "An insincere or sarcastic way of saying \"that's too bad\", or \"deal with it\""
            }
        ]
    },
    {
        question: "This photo was taken before what activity?",
        image: "/images/funny_roy_anne.jpg",
        answers: [
            {
                type: "ok",
                content: "Hiking"
            },
            {
                type: "terrible",
                content: "Crocodile hunting"
            },
            {
                type: "amazing",
                content: "Zip-lining"
            }
        ]
    },
    {
        question: "If you find the right answer here your present will be on the next page, what does Tom say about his affection for Cassie?",
        image: "/images/cassie_wink.gif",
        answers: [
            {
                type: "ok",
                content: "He loves her heaps"
            },
            {
                type: "amazing",
                content: "He loves her buckets"
            },
            {
                type: "terrible",
                content: "He thinks Cas is a cute little one"
            }
        ]
    },
];

export default quizQuestions;